<mat-form-field [appearance]="appearance">
  <mat-label>{{label}}</mat-label>
  <mat-chip-grid
    #chipList
    [required]="required"
    [errorStateMatcher]="errorMatcher"
  >
    <mat-chip-row
      *ngFor="let item of control.value"
      [ngClass]="{'invalid': !isValid(item)}"
      (removed)="remove(item)"
      [removable]="removable"
    >
   
    <span *ngIf="!isValid(item)" [matTooltip]="translations['tooltop.message.pool.invalidexam']">
      {{getItemDisplay(item)}}
    </span>
    <span *ngIf="isValid(item)">
      {{getItemDisplay(item)}}
    </span>
    <button
      *ngIf="removable"
      matChipRemove
      [attr.aria-label]="'label.aria.remove' | translate:getItemDisplay(item)  | async"
    >
      <mat-icon>
        close
      </mat-icon>
    </button>
    </mat-chip-row>
    <input
      #autoCompleteInput
      [placeholder]="placeholder"
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    >
  </mat-chip-grid>
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="select($event)"
    [autoActiveFirstOption]="true"
  >
    <app-auto-complete-loader>
     
      <mat-option
        *ngFor="let item of filteredItems | async"
        [value]="item"
        data-testid="option"
      >
      <span [innerHTML]="getItemDisplay(item) | boldMatchingText: inputControl.value" [matTooltip]="getItemDisplay(item)"></span>
      </mat-option>

      <mat-option *ngIf="isLoading" disabled></mat-option>
    
    </app-auto-complete-loader>
  </mat-autocomplete>
</mat-form-field>
